export const initializeThankYouPCPage = () => {
  let countdown = document.querySelector('.redirect-link .countdown')
  let countdownValue = 5

  const updateCountdown = () => {
    if (countdown) {
      countdown.textContent = countdownValue
    }
    if (countdownValue <= 0) {
      window.location.href = document.querySelector('.redirect-link a').href
    } else {
      countdownValue--
      setTimeout(updateCountdown, 1000)
    }
  }

  updateCountdown()
}